import React from 'react';

const About = () => {
  return (
    <section id="about">
      <div className="section-header animate-fade-in-up">
        <span className="section-number">01.</span>
        <h2 className="section-title">About Me</h2>
        <div className="section-line"></div>
      </div>
      <div className="about-content">
  <div className="about-text animate-fade-in-left delay-2">
  <p>
    Computer Science undergraduate (2023–2027) at Canara Engineering College, Mangalore.
  </p>

  <p>
    Backend-first ML Engineer with hands-on experience in Python, Flask, Django, and FastAPI,
    focused on building scalable, maintainable, and secure backend services for AI-driven applications.
  </p>

  <p>
    Skilled in developing end-to-end machine learning pipelines, including data preprocessing,
    feature engineering, model training, evaluation, and deployment.
  </p>

  <p>
    Strong experience with Retrieval-Augmented Generation (RAG) systems, embeddings,
    vector databases, and retrieval pipelines for large language model applications.
  </p>

  <p>
    Proficient in Natural Language Processing (NLP) using NLTK and spaCy,
    along with Deep Learning techniques such as CNNs, LSTMs, and Transformers,
    and exposure to multimodal analysis using MediaPipe and OpenCV.
  </p>

  <p>
    Experienced in Docker-based containerization, Git-driven development workflows,
    unit and integration testing, and modular, production-ready system design.
  </p>

  <p>
    Comfortable working with relational databases like PostgreSQL and SQLite
    and integrating REST APIs into backend systems.
  </p>

  <p>
    Goal: Build production-ready AI systems that scale efficiently,
    optimize performance, and deliver measurable real-world impact.
  </p>

  <p>
    Here are a few technologies I’ve been working with recently:
  </p>

  <ul className="skills-list">
    <li>Python</li>
    <li>Flask, Django & FastAPI</li>
    <li>PostgreSQL & SQLite</li>
    <li>Machine Learning & Deep Learning</li>
    <li>RAG, Embeddings & Vector Databases</li>
    <li>TensorFlow, Keras & scikit-learn</li>
    <li>NLTK, spaCy, MediaPipe & OpenCV</li>
    <li>Docker</li>
    <li>Git & Version Control</li>
  </ul>
</div>

        <div className="about-stats animate-fade-in-right delay-2">
          <div className="stat animate-scale-in delay-3">
            <h3>1+</h3>
            <p>Years of Experience</p>
          </div>
          <div className="stat animate-scale-in delay-4">
            <h3>10+</h3>
            <p>Projects Completed</p>
          </div>
          <div className="stat animate-scale-in delay-5">
            <h3>15+</h3>
            <p>Technologies Mastered</p>
          </div>
          <div className="stat animate-scale-in delay-5">
            <h3>100+</h3>
            <p>Commits This Year</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;